import { useEffect } from 'react';
import { navigate } from "@reach/router"

const ApparatusInspectionPage = () => {
  useEffect(() => {
    navigate('/solutions/industries/emergency-services/');
  }, []);
  return null;
};

export default ApparatusInspectionPage;
